/* facets.js — CuteDutch native filters: AJAX (Section Rendering API) + mobiele drawer.
   Progressive enhancement: zonder JS werken de facet-links/forms via full page reload.
   Werkt op collectie (sectie-id via [data-facet-section]) en zoek (main-search). */
(function () {
  'use strict';

  function sectionEl() { return document.querySelector('[data-facet-section]'); }

  // Voeg section_id + rendering-view toe aan een URL voor de Section Rendering API.
  function toSectionUrl(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function setLoading(on) {
    var root = document.querySelector('.cd-collection, .cd-search');
    if (root) root.classList.toggle('is-loading', !!on);
  }

  // Haal de gefilterde sectie op en wissel de inhoud van [data-facet-section].
  function navigate(url, push) {
    var current = sectionEl();
    if (!current) { window.location.href = url; return; }
    var sectionId = current.getAttribute('data-facet-section');
    setLoading(true);
    fetch(toSectionUrl(url, sectionId), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-facet-section]');
        if (!fresh) { window.location.href = url; return; }
        current.innerHTML = fresh.innerHTML;
        if (push) window.history.pushState({ cdFacets: true }, '', url);
        // scroll naar boven van de resultaten op paginatie/sort
        var top = current.getBoundingClientRect().top + window.pageYOffset - 100;
        if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
        setLoading(false);
      })
      .catch(function () { window.location.href = url; });
  }

  // ===== Event-delegatie (overleeft AJAX-swaps) =====
  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-facet-section]');
    // Mobiele drawer openen/sluiten mag overal
    var openBtn = e.target.closest('[data-facet-open]');
    if (openBtn) { var d = document.querySelector('[data-facet-drawer]'); if (d) d.classList.add('is-open'); return; }
    var closeBtn = e.target.closest('[data-facet-close]');
    if (closeBtn) { var d2 = document.querySelector('[data-facet-drawer]'); if (d2) d2.classList.remove('is-open'); return; }

    // Sort-dropdown openen/sluiten (custom on-brand dropdown)
    var sortToggle = e.target.closest('[data-cd-sort-toggle]');
    if (sortToggle) {
      var sWrap = sortToggle.closest('[data-cd-sort]');
      var wasOpen = sWrap.classList.contains('is-open');
      document.querySelectorAll('[data-cd-sort].is-open').forEach(function (o) { o.classList.remove('is-open'); });
      sWrap.classList.toggle('is-open', !wasOpen);
      sortToggle.setAttribute('aria-expanded', String(!wasOpen));
      return;
    }
    // Klik buiten een open sort-dropdown -> sluiten
    if (!e.target.closest('[data-cd-sort]')) {
      document.querySelectorAll('[data-cd-sort].is-open').forEach(function (o) { o.classList.remove('is-open'); });
    }

    if (!root) return;

    // Facet-links (checkbox-toggle, actieve chips, "verwijder alles")
    var link = e.target.closest('[data-facet-link], [data-facet-clear]');
    if (link && link.getAttribute('href')) { e.preventDefault(); navigate(link.getAttribute('href'), true); return; }

    // Paginatielinks binnen de resultaten
    var pag = e.target.closest('.cd-results .pagination a[href]');
    if (pag) { e.preventDefault(); navigate(pag.getAttribute('href'), true); return; }
  });

  // Prijs-form submit
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-facet-price], [data-facet-sort]');
    if (!form || !sectionEl()) return;
    e.preventDefault();
    var params = new URLSearchParams(new FormData(form));
    var url = form.getAttribute('action') + '?' + params.toString();
    navigate(url, true);
  });

  // Sort-select change -> submit het sort-form
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-facet-sort-select]');
    if (!sel) return;
    var form = sel.closest('[data-facet-sort]');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  });

  // Back/forward
  window.addEventListener('popstate', function () { navigate(window.location.href, false); });
})();
